// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__mVrhc","grid":"blog_grid__12zC7"};